import type { FC } from "react";
import type { OrderSummaryDTO } from "../../../libs/mypage/orderResolver";
import type { UnifiedOrderStatus } from "../../../libs/mypage/orderStatus";
import { summaryStatusLabel } from "./format";

type Props = {
  order: Pick<OrderSummaryDTO, "status">;
};

const DOT_BY_STATUS: Record<UnifiedOrderStatus, string> = {
  PENDING_PAYMENT: "bg-amber-500",
  EXPIRED_PAYMENT: "bg-neutral-400",
  NOT_IMPORTED: "bg-neutral-400",
  AWAITING_CONFIRMATION: "bg-amber-500",
  AWAITING_STOCK: "bg-neutral-500",
  PREPARING: "bg-neutral-700",
  WORKING: "bg-neutral-700",
  PARTLY_SHIPPED: "bg-neutral-900",
  SHIPPED: "bg-neutral-900",
  PROCESSING: "bg-neutral-400",
  CANCELLED: "bg-neutral-300",
  REFUNDED: "bg-neutral-300",
};

export const StatusLabel: FC<Props> = ({ order }) => {
  const dotClass = DOT_BY_STATUS[order.status];
  return (
    <span className="inline-flex items-center gap-2 text-neutral-500 text-xs">
      <span className={`inline-block size-1.5 rounded-full ${dotClass}`} />
      {summaryStatusLabel(order)}
    </span>
  );
};
